// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"5505e964","31":"b156241b","242":"5765dbd2","358":"4b4e998a","413":"83159c4a","513":"228fc47f","787":"b41196d0","891":"4bbd9da6","944":"ad977ba6"}[chunkId] + ".chunk.js";
};